module.exports = __webpack_public_path__ + "img/fast-delivery-color.89795c28.png";